<template>
    <div class="announce" v-if="false">
        <div class="announce__logo">
            <div class="announce__logo-top">
                <svg-icon width="26" height="26" name="corner"></svg-icon>
                <svg-icon width="26" height="26" name="corner"></svg-icon>
            </div>
            <p class="announce__logo-text">symbios</p>
            <div class="announce__logo-bottom">
                <svg-icon width="26" height="26" name="corner"></svg-icon>
                <svg-icon width="26" height="26" name="corner"></svg-icon>
            </div>
        </div>
        <div class="announce__footer">
            <time datetime="2024-07-03T03:45:00+0100">07/03/24 3:45 Mosc</time>
            <div class="announce__footer-diamonds" v-if="!isAnimationComplete">
                <span
                    v-for="(diamond, index) in diamonds"
                    class="announce__footer-diamond"
                    :key="index"
                    :class="diamonds[index] ? 'announce__footer-diamond--filled' : null"></span>
            </div>
            <div class="announce__footer-link" v-else>
                <nuxt-link to="/symbios/posts">
                    <svg-icon name="arrow-right--big" width="152" height="23" v-if="$device.isDesktop" />
                    <svg-icon name="arrow-right--big-mobile" width="188" height="23" v-else />
                </nuxt-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Collaboration",
    head() {
        return {
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: this.seo?.description ? this.seo.description : "",
                },
                {
                    hid: "og:description",
                    property: "og:description",
                    content: this.seo?.description ? this.seo.description : "",
                },
                {
                    hid: "keywords",
                    property: "keywords",
                    content: this.seo?.keywords ? this.seo.keywords : "",
                },
            ],
        };
    },
    data() {
        return {
            seo: {},
            diamonds: [0, 0, 0, 0, 0],
            isAnimationComplete: false,
        };
    },
    async asyncData({ $axios }) {
        const seo = await $axios.get("/api/seo/symbios");
        return {
            seo: seo.data,
        };
    },
    methods: {
        getCrumbs() {
            return [
                {
                    name: this.$i18n.t("symbios"),
                },
            ];
        },
    },
    mounted() {
        this.$store.commit("crumbs/change", this.getCrumbs());

        (() => {
            let index = 0;
            let diamondsInterval = setInterval(() => {
                if (index < this.$data.diamonds.length) {
                    let value = this.$data.diamonds[index] ? 0 : 1;
                    this.$set(this.$data.diamonds, index, value);
                    index++;
                } else {
                    clearInterval(diamondsInterval);
                    this.$data.isAnimationComplete = true;
                }
            }, 1000);
        })();

        // let index = 0;
        // setInterval(() => {
        //   index = index < this.$data.diamonds.length ? index : 0;
        //   if (index === 0 && this.$data.diamonds[1] === 1) {
        //     this.$data.diamonds = [0, 0, 0, 0, 0];
        //   } else {
        //     let value = this.$data.diamonds[index] ? 0 : 1;
        //     this.$set(this.$data.diamonds, index, value);
        //     index++;
        //   }
        // }, 1000);
    },
};
</script>

<style lang="less" scoped>
.announce {
    background-color: #000000;
    width: 100%;
    height: 853px;
    color: #ffffff;
    display: flex;
    gap: 20px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media @sm {
        height: calc(100dvh + 50px);
        gap: 12px;
    }
    &__logo {
        width: 100%;
        max-width: 362px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        @media @sm {
            max-width: 187px;
            margin-top: -50px;
        }
        &-top,
        &-bottom {
            display: flex;
            justify-content: space-between;
            @media @sm {
                svg {
                    width: 18px;
                    height: 18px;
                }
            }
        }
        &-top svg:last-child {
            transform: rotate(90deg);
        }
        &-text {
            text-align: center;
            font-size: 52px;
            font-weight: 550;
            line-height: 62px;
            letter-spacing: 3%;
            @media @sm {
                font-size: 28px;
                line-height: 34px;
            }
        }
        &-bottom {
            svg:first-child {
                transform: rotate(-90deg);
            }
            svg:last-child {
                transform: rotate(180deg);
            }
        }
    }
    &__footer {
        max-width: 362px;
        height: 29px;
        display: flex;
        align-items: center;
        gap: 22px;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: 0.03em;
        text-align: left;
        @media @sm {
            flex-direction: column;
            align-items: center;
            gap: 16px;
        }
        time {
            white-space: nowrap;
        }
        &-diamonds {
            display: flex;
            align-items: center;
            gap: 23px;
            @media @sm {
                gap: 19px;
            }
            .announce__footer-diamond {
                display: block;
                width: 11.32px;
                height: 11.32px;
                border: 1px solid #ffffff;
                background-color: transparent;
                transform: rotate(45deg);
                @media @sm {
                    width: 8.49px;
                    height: 8.49px;
                }
                &--filled {
                    background-color: #ffffff;
                }
            }
        }
        &-link {
            margin-top: 6px;
            @media @sm {
                margin-top: -5px;
            }
        }
    }
}
</style>
